import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import GoogleSlidesExport from "components/ChatGPT/GoogleSlidesExport";

import * as nextReducer from "containers/Next/NextReducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as viewReducer from "containers/View/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as schemaMonitorReducer from "containers/SchemaMonitor/reducer";

class GoogleSlidesExportContainer extends React.PureComponent {
  render() {
    return <GoogleSlidesExport {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  // init: () => dispatch(chatGPTReducer.init()),
  resetGPT: () => dispatch(chatGPTReducer.resetGPT())
});

const mapStateToProps = (state, ownProps) => {
  return {
    exportCharts: chatGPTReducer.getChartsFromMessage(state, ownProps.mIndex)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(GoogleSlidesExportContainer);
